export const manualUniquesList: { category: string; items: string[] }[] = [
];
